<template>
    <transition name="fade">
        <slot></slot>
    </transition>
</template>

<style>
.fade-enter-from,
.fade-leave-to {
    opacity: 0 !important;
}
</style>
